import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';
import queryString from 'query-string';
import { validateQueryParameters } from '../../helpers/verifyQueryParameters';

export default {
  getUsers(categories) {
    return axiosPlataformaClient.custAxios().get(`/academic/courses/enrollment?enrollmentStatusId=1&listCourses=${categories.join(',')}`);
  },
  getCourses({ isToGetOnlyActual = false }) {
    const stringified = queryString.stringify({ isToGetOnlyActual }, { skipNull: true, skipEmptyString: true });
    return axiosPlataformaClient.custAxios().get(`/academic/courses/enrollment/category${stringified && `?${stringified}`}`);
  },
  getAllRoles({ isEnrolled, filterByIsActive }) {
    const queryParams = validateQueryParameters({ isEnrolled, filterByIsActive });
    return axiosPlataformaClient.custAxios().get(`/academic/courses/role?${queryParams}`);
  },
  getDefaultRoles() {
    return axiosPlataformaClient.custAxios().get('/academic/role');
  },
  getBatchesProcess(params) {
    const query = validateQueryParameters(params);
    return axiosPlataformaClient.custAxios().get(`/academic/batches/processes?${query}`);
  },
  getBatchesProcessFilters(params) {
    const query = validateQueryParameters(params);
    return axiosPlataformaClient.custAxios().get(`/academic/batches/processes/filters?${query}`);
  },
  startBatchProcess({ params, payload }) {
    let file = null;
    if (params.file) {
      file = params.file;
      delete params.file;
    }

    const query = validateQueryParameters(params);
    const formData = new FormData();
    formData.append('data', JSON.stringify(payload));
    formData.append('file', file);

    return axiosPlataformaClient.custAxios().post(
      `/academic/batches?${query}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
  getBatchEvaluationBlocks({ params, payload, file = null }) {
    const queryParams = validateQueryParameters(params);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('data', JSON.stringify(payload));

    return axiosPlataformaClient.custAxios().post(
      `/academic/batches/courses/grade-categories?${queryParams}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
};
